import type Uppy from '@uppy/core';

export const RECEIPT_MAX_FILE_SIZE = 1024 * 1024 * 3;

let uppyPromise: Promise<Uppy> | undefined;

// SPAY-5216: Uppy (with webcam, exifr and preact) was ~260 KB of main.js, though only the receipt upload
// screens use it. It is now a separate chunk, loaded once by useOrderReceipts when the order reaches one.
export const loadReceiptUppy = (): Promise<Uppy> => {
  uppyPromise ??= Promise.all([import('@uppy/core'), import('@uppy/webcam')])
    .then(([{ default: UppyCore }, { default: Webcam }]) =>
      new UppyCore({
        autoProceed: false,
        allowMultipleUploads: false,
        restrictions: {
          maxNumberOfFiles: 1,
          allowedFileTypes: ['image/*', 'application/pdf'],
          maxFileSize: RECEIPT_MAX_FILE_SIZE,
        },
      }).use(Webcam),
    )
    .catch((error) => {
      // A failed chunk load (flaky network, a deploy in between) can be retried on the next attempt.
      uppyPromise = undefined;
      throw error;
    });
  return uppyPromise;
};
